module.exports = __webpack_public_path__ + "static/what-is-a-session-replay-54d46eea3d6d4fbf4ca13dacc9312f7b.png";